
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetovanisaptashrungi() {



    const cardData =
    {
        keyword: 'Pune to Vani Saptashrungi Cab Booking Services',
        heading: 'S9 Travels: Pune to Vani Saptashrungi Cab Booking Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services for your journey from Pune to Vani Saptashrungi. Located in the foothills of the Sahyadri mountain range, Vani is renowned for the Saptashrungi Temple, dedicated to Goddess Saptashrungi, one of the prominent Shakti Peethas in India. Whether you are visiting for spiritual reasons or exploring the serene surroundings, we ensure a smooth and comfortable journey. Vani is approximately 180 km from Pune, with a travel time of around 4 to 5 hours by road. With our well-maintained fleet and professional drivers, enjoy a hassle-free and safe ride to your destination.',

        top: 'Top Places to Visit in Vani with S9 Travels',

"topPlaces": [
    {
      "title": "Saptashrungi Temple",
      "description": "The Saptashrungi Temple is the main attraction in Vani, dedicated to Goddess Saptashrungi. The temple is situated atop a hill and is one of the 51 Shakti Peethas in India. The temple is famous for its historical significance, beautiful architecture, and spiritual ambiance. A visit to this temple is considered highly auspicious, and many devotees embark on a challenging trek to reach the temple."
    },
    {
      "title": "Saptashrungi Fort",
      "description": "The Saptashrungi Fort is located near the temple and offers a beautiful and scenic trekking experience. The fort, surrounded by lush greenery and hills, provides a panoramic view of the surrounding landscape. It is ideal for adventure enthusiasts and history buffs looking to explore the historical ruins while enjoying nature."
    },
    {
      "title": "Vani Lake",
      "description": "Vani Lake is a tranquil and serene spot, perfect for unwinding after your visit to the temple. The lake, surrounded by natural beauty, offers a peaceful environment for relaxation and photography. The surrounding hills enhance the beauty of this scenic location."
    },
    {
      "title": "Saptashrungi Waterfalls",
      "description": "The Saptashrungi Waterfalls are a must-see if you're visiting the area during the monsoon. The waterfalls cascade down the mountainside, offering a stunning sight surrounded by lush greenery. It’s a great spot for nature lovers and photographers to capture the beauty of the region."
    },
    {
      "title": "Bhandardara Dam",
      "description": "Located around 30 km from Vani, Bhandardara Dam is a popular picnic spot and one of the oldest dams in India. The dam is situated amidst beautiful hills and offers a picturesque view. It is also a great spot for boating and fishing."
    },
    {
      "title": "Kalsubai Peak",
      "description": "Kalsubai Peak, located near Vani, is the highest point in the Sahyadri mountain range. It offers a challenging yet rewarding trek, with breathtaking views from the summit. For adventure enthusiasts, it is an excellent spot to explore the natural beauty of the Western Ghats."
    },
    {
      "title": "Alang-Madan-Kulang Trek",
      "description": "The Alang-Madan-Kulang Trek is a famous trekking route near Vani that takes trekkers through rugged terrain and offers stunning views of the surrounding hills. This challenging trek is Efficient for experienced trekkers looking for an adventure in the Sahyadri mountains."
    },
    {
      "title": "Wadi (Village of Vani)",
      "description": "Wadi, a small village near Vani, is known for its simple, traditional way of life. The village is a peaceful retreat for those looking to experience rural Maharashtra. The surrounding nature, farms, and hills make it a perfect place for short walks and photography."
    },
    {
      "title": "Panchavati Temple",
      "description": "The Panchavati Temple in Vani is dedicated to Lord Shiva and is another important religious site. The temple is located amidst scenic surroundings and offers a tranquil atmosphere for meditation and prayer."
    }
],

"services": [
    {
      "name": "Book Pune to Vani Saptashrungi Taxi",
      "description": "Traveling from Pune to Vani Saptashrungi? S9 Travels offers reliable and comfortable taxi services for a smooth and hassle-free journey to Vani Saptashrungi, a sacred site famous for the Saptashrungi Devi Temple. Whether you're visiting for a spiritual journey or leisure, our fleet of well-maintained vehicles ensures comfort throughout the trip."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Cab Service",
      "description": "Booking a cab service from Pune to Vani Saptashrungi is easy with S9 Travels. We offer both one-way and round-trip options to meet your travel needs. Our experienced drivers and well-maintained vehicles guarantee a pleasant and safe journey from Pune to Vani Saptashrungi, providing you with a stress-free travel experience."
    },
    {
      "name": "Book Pune to Vani Saptashrungi One-Way Taxi",
      "description": "Looking for a one-way taxi from Pune to Vani Saptashrungi? S9 Travels provides affordable and convenient one-way taxi services to this holy destination. Whether you are traveling alone, with family, or friends, our comfortable and reliable taxis ensure that your one-way trip is pleasant and punctual."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Round Trip",
      "description": "For a round trip to Vani Saptashrungi, S9 Travels offers affordable and convenient options. We ensure a hassle-free journey both ways, from Pune to Vani Saptashrungi and back. Choose our round-trip services for a comfortable and efficient travel experience with flexible timings and professional drivers."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Taxi Fare",
      "description": "At S9 Travels, we offer competitive and transparent taxi fares for your journey from Pune to Vani Saptashrungi. Our pricing is clear and without hidden charges, ensuring you get the best value for your trip. Contact us for a personalized taxi fare quote based on your travel requirements."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Car Rental",
      "description": "For those seeking flexibility, S9 Travels offers car rental services from Pune to Vani Saptashrungi. Rent a car and travel at your own pace, enjoying the scenic routes and freedom to explore. We offer a wide range of vehicles, from budget-friendly to luxury options, to suit your preferences."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Luxury Taxi",
      "description": "For a more premium experience, S9 Travels offers luxury taxi services for your journey to Vani Saptashrungi. Enjoy a comfortable and stylish ride with top-class amenities, ensuring a relaxed and indulgent travel experience. Ideal for those looking for extra comfort and elegance during their pilgrimage."
    },
    {
      "name": "Book Pune to Vani Saptashrungi Efficient Taxi",
      "description": "S9 Travels also offers Efficient Taxi services for budget-conscious travelers. Share your ride with others, and enjoy an affordable journey to Vani Saptashrungi without compromising on comfort. It’s a great way to reduce travel costs while experiencing a comfortable ride."
    },
    {
      "name": "Vani Saptashrungi Temple Taxi",
      "description": "Visiting the Saptashrungi Devi Temple? S9 Travels offers specialized temple taxi services for your visit to this sacred site. Our experienced drivers know the best routes, ensuring you have a seamless journey to the temple. We also offer flexible timings to accommodate your prayer and sightseeing schedules."
    },
    {
      "name": "Pune to Vani Saptashrungi Tour",
      "description": "For those looking to make the most of their trip to Vani Saptashrungi, S9 Travels offers customized tour packages. Enjoy a well-planned trip with a professional driver who will guide you on the best routes and places of interest. Our tour services ensure you can explore the sacred site and its surroundings with ease."
    },
    {
      "name": "Affordable Taxi to Vani Saptashrungi",
      "description": "At S9 Travels, we offer affordable taxi services to Vani Saptashrungi, ensuring that your pilgrimage or leisure trip doesn’t break the bank. We provide quality service at competitive prices, allowing you to enjoy a comfortable and economical ride to this revered destination."
    },
    {
      "name": "Private Taxi from Pune to Vani Saptashrungi",
      "description": "For those seeking a private and personalized experience, S9 Travels provides private taxi services from Pune to Vani Saptashrungi. Enjoy a peaceful journey, customized to your travel preferences, with a dedicated driver to ensure your comfort and safety throughout the trip."
    },
    {
      "name": "Vani Saptashrungi Yatra Cab",
      "description": "Make your Saptashrungi Yatra special with S9 Travels. We offer yatra cab services that ensure a comfortable and organized pilgrimage experience. Our professional drivers will take you through the best routes, and we provide well-maintained vehicles to make your journey smooth and enjoyable."
    },
    {
      "name": "Vani Saptashrungi Temple Tour Cab",
      "description": "Planning a temple tour to Vani Saptashrungi? S9 Travels offers temple tour cab services, ensuring a stress-free and peaceful experience. Our cabs are well-equipped to provide comfort, and our experienced drivers will take you to the temple and back with convenience, allowing you to focus on your spiritual journey."
    }
],

"tableData": [
  ["Book Pune To Vani Saptashrungi Taxi", "Book Pune To Vani Saptashrungi Cab Service"],
  ["Book Pune To Vani Saptashrungi One-Way Taxi", "Book Pune To Vani Saptashrungi Round Trip"],
  ["Book Pune To Vani Saptashrungi Taxi Fare", "Book Pune To Vani Saptashrungi Car Rental"],
  ["Book Pune To Vani Saptashrungi Luxury Taxi", "Book Pune To Vani Saptashrungi Efficient Taxi"],
  ["Vani Saptashrungi Temple Taxi", "Pune to Vani Saptashrungi Tour"],
  ["Affordable Taxi to Vani Saptashrungi", "Private Taxi from Pune to Vani Saptashrungi"],
  ["Vani Saptashrungi Yatra Cab", "Vani Saptashrungi Temple Tour Cab"],
  ["", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality when traveling to the sacred Vani Saptashrungi Temple. Our drivers ensure timely pickups and drop-offs, allowing you to enjoy a seamless trip to the holy site and its spiritual surroundings."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles for your journey from Pune to Vani Saptashrungi. Whether you prefer a sedan, SUV, or a premium vehicle, all our cars are equipped with air conditioning, comfortable seating, and spacious interiors for a relaxing and comfortable ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the best routes to Vani Saptashrungi. They ensure a safe, smooth, and enjoyable journey, allowing you to focus on your spiritual experience or leisure trip without any worries."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Vani Saptashrungi trip. There are no hidden charges, and we provide a clear breakdown of costs, so you know exactly what to expect and can plan your journey with ease."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring that you have a secure and comfortable ride to Vani Saptashrungi."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return, S9 Travels operates around the clock to meet your needs. Our customer service team is always available to assist you with bookings, inquiries, or any other travel-related assistance."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Vani Saptashrungi trip is easy and convenient with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling to Vani Saptashrungi for religious purposes or leisure, we offer customized travel packages tailored to your needs and preferences. Let us know your requirements, and we’ll ensure that your trip is special and memorable."
  }
]























    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Vani Saptashrungi cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can book online through our website or app, or you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Vani Saptashrungi trip?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to provide comfort and safety during the trip.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Vani Saptashrungi?',
            answer: 'Yes, our drivers are experienced in long-distance travel and are familiar with the best routes to Vani Saptashrungi. They ensure a safe and smooth journey, making your trip comfortable and stress-free.',
          },
          {
            question: 'How do I pay for my Pune to Vani Saptashrungi cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it easy and convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Vani Saptashrungi?',
            answer: 'Yes, we can arrange a round-trip for you. Just provide us with your return details, and we will ensure a comfortable and timely return journey from Vani Saptashrungi.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Vani Saptashrungi?',
            answer: 'Yes, we offer sightseeing services around Vani Saptashrungi. Explore the temple, the surrounding hills, and nearby attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Vani Saptashrungi cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Vani Saptashrungi?',
            answer: 'Yes, we offer corporate and group travel services to Vani Saptashrungi. Whether it’s a corporate outing or a family trip, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Vani Saptashrungi journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Vani Saptashrungi.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Arvind Jadhav',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my visit to Vani Saptashrungi. The driver was prompt, and the vehicle was clean and comfortable. It was a smooth ride, and I felt very safe. Highly recommend S9 Travels for a peaceful trip!”',
        },
        {
          name: 'Mrs. Sunita Shinde',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to Vani Saptashrungi was made easy and comfortable by S9 Travels. The vehicle was spacious and clean, and the driver was courteous and professional. We had a wonderful time, and we’ll definitely book again for our next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Vani Saptashrungi Cab Booking",
        "description": "Book Pune to Vani Saptashrungi taxi services with S9 Travels. We offer one-way, round-trip, luxury taxis, and affordable car rentals for your Vani Saptashrungi temple visit. Choose private or Efficient Taxis, enjoy group cab bookings, and explore the temple with a reliable taxi service from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Vani Saptashrungi Cab Booking | Affordable Taxi & Temple Tour | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Vani Saptashrungi cab services for one-way and round-trip rides. Enjoy affordable taxi options, private or Efficient Taxis, and luxury car rentals for your Vani Saptashrungi temple tour and yatra. Best rates for Vani Saptashrungi temple taxi services and group bookings." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetovanisaptashrungi;